import { Component, Input } from '@angular/core';
import { IVehicleAddress } from '../../../../interfaces/task-info';
import { JobScreenTaskTimesTask } from '../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'job-screen-location',
  templateUrl: './job-screen-location.html',
  styleUrls: ['./job-screen-location.scss'],
})
export class JobScreenLocationComponent {
  @Input('location') location: IVehicleAddress;
  @Input('task') task: JobScreenTaskTimesTask;
  @Input('earliestTime') earliestTime: Date;
  @Input('latestTime') latestTime: Date;
  @Input('IsPickup') IsPickup: boolean;
  @Input('originalEarliestDateTime') originalEarliestDateTime: Date;
  @Input('originalLatestDateTime') originalLatestDateTime: Date;

  get TypeLabel(): string {
    return this.IsPickup ? 'Pick-up' : 'Drop-off';
  }
}
